// Side-effect-only module: must stay the very first import of src/index.js. ES imports are
// hoisted, so a guard call in the module body would run after all other imports were
// evaluated. On a foreign host this throws and stops the bundle (ClickUp 869fjuh69).
import { enforceOwnHost } from './hostGuard';

enforceOwnHost();
